<template>
  <VueCustomTooltip
    :label="text"
    :sticky="false"
    :multiline="true"
    :class="className ? `vue-custom-tooltip-text ${className}` : 'vue-custom-tooltip-text'"
  >

    <span class="material-symbols-outlined">
      help
    </span>
  </VueCustomTooltip>
</template>

<script>

import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';

export default {
  name: 'TooltipText',
  components: {
    VueCustomTooltip,
  },
  props: {
    text: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: () => 'is-top'
    },
    positionCustom: {
      type: Array,
      default: () => []
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      calculatedPosition: null,
    }
  },
  computed: {
    positionTooltip() {
      return this.calculatedPosition || this.position;
    },
  },
  mounted() {
    window.addEventListener('resize', this.setCalculatedPosition, { passive: true });

    this.setCalculatedPosition();
  },
  methods: {
    setCalculatedPosition() {
      if (!this.positionCustom.length) {
        return;
      }

      const widthWindow = window.innerWidth;

      const position = this.positionCustom.sort(function(a, b) {
        return b[0] - a[0];
      }).find(item => widthWindow >= item[0]);

      this.calculatedPosition = position ? position[1] : null;
    },
  },
}
</script>

<style lang="scss" src="./TooltipText.styles.scss" scoped> </style>
